import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const gerenciarHomologacaoRoutes: Routes = [
  {
    path: 'gerenciar-homologacao',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        data: {
          title: 'Gerenciar Homologação do Profissional',
          roles: [Role.GERENCIAR_HOMOLOGACAO_CONSULTAR],
          breadcrumb: [{ label: 'Gerenciar Homologação do Profissional', url: '/gerenciar-homologacao' }],
        },
        loadComponent: () =>
          import('./gerenciar-homologacao.component').then((m) => m.GerenciarHomologacaoComponent),
      },
      {
        path: 'visualizar/:id',
        data: {
          title: 'Visualizar Homologação do Profissional',
          roles: [Role.GERENCIAR_HOMOLOGACAO_CONSULTAR],
          breadcrumb: [
            { label: 'Gerenciar Homologação do Profissional', url: '/gerenciar-homologacao' },
            { label: 'Visualizar Homologação' },
          ],
        },
        loadComponent: () =>
          import('./visualizar-homologacao/visualizar-homologacao.component').then(
            (m) => m.VisualizarHomologacaoComponent,
          ),
      },
      {
        path: 'reverter/:id',
        data: {
          title: 'Reverter Homologação do Profissional',
          roles: [Role.GERENCIAR_HOMOLOGACAO_REVERTER],
          breadcrumb: [
            { label: 'Gerenciar Homologação do Profissional', url: '/gerenciar-homologacao' },
            { label: 'Reverter Homologação' },
          ],
        },
        loadComponent: () =>
          import('./reverter-homologacao/reverter-homologacao.component').then(
            (m) => m.ReverterHomologacaoComponent,
          ),
      },
      {
        path: 'encerrar/:id',
        data: {
          title: 'Encerrar Homologação Individual do Profissional',
          roles: [Role.GERENCIAR_HOMOLOGACAO_ENCERRAR_INDIVIDUAL],
          breadcrumb: [
            { label: 'Gerenciar Homologação do Profissional', url: '/gerenciar-homologacao' },
            { label: 'Encerrar Homologação Individual' },
          ],
        },
        loadComponent: () =>
          import('./encerrar-homologacao/encerrar-homologacao.component').then(
            (m) => m.EncerrarHomologacaoComponent,
          ),
      },
      {
        path: 'encerrar-lote',
        data: {
          title: 'Encerrar Período de Homologação em Lote',
          roles: [Role.GERENCIAR_HOMOLOGACAO_ENCERRAR_LOTE],
          breadcrumb: [
            { label: 'Gerenciar Homologação do Profissional', url: '/gerenciar-homologacao' },
            { label: 'Encerrar Período em Lote' },
          ],
        },
        loadComponent: () =>
          import('./encerrar-lote/encerrar-lote.component').then((m) => m.EncerrarLoteComponent),
      },
    ],
  },
];
